module.exports = {"home":"Home","totalApl":"Total APL","serviceOperating":"In Service","serviceIdle":"Standby","aplCommError":"APL Communication Error","lowBattery":"Low Battery","batteryOut":"Depleted","currentGreenTemp":"Current Green Temperature","lastUpdated":"Last Updated","refresh":"Refresh","averageTemp":"Average Temp","maxTemp":"Max Temp","minTemp":"Min Temp","tempStatus":"Temperature status","temperature":"Temperature","report":"Report","battery":"Battery","normal":"Normal","needCharge":"Needs Charging","noData":"No data available."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/ho101.json
// module id = sTQO
// module chunks = 2